import { AppModulesFactory } from "../Common/AppModulesFactory";
import { i18n } from "../Common/_translations";
import { ModuleModel } from "../Everou/_models";
import { VACATION_RENTAL_PLANS } from "./_constants/vacationRentalPlan.constants";
import { PMSLocationsModule } from "./ModuleLocations/PMSLocationsModule";
import { PMSIntegrationsModule } from "./ModuleIntegrations/PMSIntegrationsModule";
import { PMSReservationsModule } from "./ModuleReservations/PMSReservationsModule";
import { PMSCustomizationModule } from "./ModuleCustomization/PMSCustomizationModule";
import { PMSChatModule } from "./ModuleChat/PMSChatModule";
import { PMSOrganizationsModule } from "./ModuleOrganizations/PMSOrganizationsModule";

import locationsIcon from "../Common/_assets/icons/icon_module_locations.svg";
import organizationsIcon from "../Common/_assets/icons/icon_module_organizations.svg";
import integrationsIcon from "../Common/_assets/icons/icon_module_integrations_pms.svg";
import reservationsIcon from "../Common/_assets/icons/icon_module_reservations.svg";
import chatIcon from "../Common/_assets/icons/icon_module_chat.svg";
import customizationIcon from "../Common/_assets/icons/icon_module_customization.svg";

export const MODULE_IDS = {
    LOCATIONS:      "LOCATIONS",
    INTEGRATIONS:   "INTEGRATIONS",
    RESERVATIONS:   "RESERVATIONS",
    ORGANIZATIONS:  "ORGANIZATIONS",
    CUSTOMIZATION:  "CUSTOMIZATION",
    CHAT:           "CHAT",
};

const URLS = {
    LOCATIONS:      "/locations",
    INTEGRATIONS:   "/integrations",
    RESERVATIONS:   "/reservations",
    ORGANIZATIONS:  "/organizations",
    CUSTOMIZATION:  "/customization",
    CHAT:           "/chat",
};

const MODULES = [
    ModuleModel({
        moduleId: MODULE_IDS.LOCATIONS,
        icon: locationsIcon,
        isEnabled: true,
        uiName: i18n.t("mod_dev_locations_title"),
        url: URLS.LOCATIONS,
    }),
    ModuleModel({
        moduleId: MODULE_IDS.RESERVATIONS,
        icon: reservationsIcon,
        isEnabled: true,
        uiName: i18n.t("mod_pms_reservations"),
        url: URLS.RESERVATIONS,
    }),
    ModuleModel({
        moduleId: MODULE_IDS.CUSTOMIZATION,
        icon: customizationIcon,
        isEnabled: true,
        uiName: i18n.t("mod_pms_customization"),
        url: URLS.CUSTOMIZATION,
    }),
    ModuleModel({
        moduleId: MODULE_IDS.INTEGRATIONS,
        icon: integrationsIcon,
        isEnabled: true,
        uiName: i18n.t("mod_pms_accounts_title"),
        url: URLS.INTEGRATIONS,
    }),
    ModuleModel({
        moduleId: MODULE_IDS.ORGANIZATIONS,
        icon: organizationsIcon,
        isEnabled: true,
        uiName: i18n.t("mod_organizations_title"),
        url: URLS.ORGANIZATIONS,
    }),
    /*ModuleModel({
        moduleId: MODULE_IDS.CHAT,
        icon: chatIcon,
        isEnabled: true,
        uiName: i18n.t("mod_pms_chat"),
        url: URLS.CHAT,
    }),*/
];

const componentForModuleDictionary = {
    [MODULE_IDS.LOCATIONS]:     PMSLocationsModule,
    [MODULE_IDS.INTEGRATIONS]:  PMSIntegrationsModule,
    [MODULE_IDS.RESERVATIONS]:  PMSReservationsModule,
    [MODULE_IDS.ORGANIZATIONS]: PMSOrganizationsModule,
    [MODULE_IDS.CUSTOMIZATION]: PMSCustomizationModule,
    [MODULE_IDS.CHAT]:          PMSChatModule,
};

// Minimum account plan (highest-plan location) required to see each gated
// module. Modules not listed here are always available. Reservations and
// Organizations need PREMIUM; Customization is open to FREE for now.
const MODULE_MIN_PLAN = {
    [MODULE_IDS.RESERVATIONS]:  VACATION_RENTAL_PLANS.PREMIUM_PLAN,
    [MODULE_IDS.ORGANIZATIONS]: VACATION_RENTAL_PLANS.PREMIUM_PLAN,
    [MODULE_IDS.CUSTOMIZATION]: VACATION_RENTAL_PLANS.FREE_PLAN,
};

// Membership is what opens Organizations, not the plan: the backend already
// gated the plan when the locations were linked, and creating an organization
// moves the personal templates into it -- hiding the module would strand them.
// The standalone PMS accounts and Customization modules keep their own
// gating: an organization's members also reach them from its tabs.
function getEnabledModuleIds(
    highestPlan = VACATION_RENTAL_PLANS.NO_PLAN,
    hasOrganizations = false,
) {
    return MODULES
        .filter(module => module.isEnabled)
        .filter(module => {
            if (hasOrganizations && module.moduleId === MODULE_IDS.ORGANIZATIONS)
                return true;
            const minPlan = MODULE_MIN_PLAN[module.moduleId];
            return minPlan === undefined || highestPlan >= minPlan;
        })
        .map(module => module.moduleId)
    ;
}

export const PMSModules = AppModulesFactory.makeModules({
    ALL_MODULES: MODULES,
    getEnabledModuleIds,
    componentForModuleDictionary,
    DEFAULT_MODULE: MODULE_IDS.LOCATIONS,
});